import styled from '@emotion/styled'

import { AssetInformation, Space, TextInput } from '../../../../../components/core-v2'
import Icon from '../../../../../components/core-v2/atoms/Icon'
import IconButton from '../../../../../components/core-v2/molecules/iconButton'
import LinkIcon from '../../../../../components/core-v2/molecules/linkIcon'
import { AssetResult } from '../state/portfolio-slice'
import { Asset } from '../types'
import { AssetsTable } from './assets-table'

export type AssetFinderProps = {
  assetBeingInspected?: Asset
  assets: AssetResult[]
  onChangeSearchTerm: (val: string) => void
  onClickBackToSearch: () => void
  onInspectAsset: (val: string) => void
  onSelectAsset: (asset: Asset) => void
  searchTerm: string
  status: 'finding' | 'inspecting'
}

const StyledActions = styled.div`
  border-top: 1px solid var(--White90);
`

export const AssetFinder = ({
  assetBeingInspected,
  assets,
  onChangeSearchTerm,
  onClickBackToSearch,
  onInspectAsset,
  onSelectAsset,
  searchTerm,
  status
}: AssetFinderProps) => {
  if (status === 'finding') {
    return (
      <Space mx={5} my={6}>
        <Space flexGrow={1} mb={6}>
          <TextInput value={searchTerm} onChange={e => onChangeSearchTerm(e.target.value)} />
        </Space>
        <AssetsTable assets={assets} onClickAsset={id => onInspectAsset(id)} />
      </Space>
    )
  }

  if (status === 'inspecting') {
    if (!assetBeingInspected) {
      return (
        <Space px={5} py={6}>
          Loading...
        </Space>
      )
    }
    return (
      <Space isflex flexDirection="column">
        <AssetInformation asset={assetBeingInspected} />
        <StyledActions>
          <Space isflex alignItems="center" justifyContent="space-between" p={6}>
            <LinkIcon
              disabled={false}
              icon={<Icon name="chevronLeft" size="small" />}
              iconPosition="left"
              text="Back to search"
              onClick={() => onClickBackToSearch()}
            />
            <IconButton
              data-testid="btn-choose"
              disabled={false}
              icon={<Icon name="chevronRight" size="default" />}
              iconPosition="right"
              operationType="progress"
              text="Choose"
              onClick={() => onSelectAsset(assetBeingInspected)}
            />
          </Space>
        </StyledActions>
      </Space>
    )
  }
}
